import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ApprovalstatusService {

  URL = this.ConfigService.getAPIBaseUrl() + 'api/ApprovalConfirmation_Details/';

  constructor(private HttpClient: HttpClient, private ConfigService: ConfigurationService) { }


  SaveTaxation(data) {
    debugger;
    return this.HttpClient.post(this.URL + "InsertApprovalConfirmation_Details", data)
  }
   
  GetOneTaxation(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URL + "GetApprovalConfirmation_Details?APPeriodId=" + APPeriodId)
  }
}
